'use strict';

import React from 'react'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Layout from '@Layout/BackOffice'

let app = window.app;

const types =
[
	{ value: 'text', label: 'Texte' },
	{ value: 'date', label: 'Date' },
	{ value: 'number', label: 'Nombre' },
	{ value: 'textarea', label: 'Texte long' },
	{ value: 'select', label: 'Choix unique (liste déroulante)' },
	{ value: 'checkbox', label: 'Choix multiple' },
];

export default class AddCustomQuoteElement extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			label_id: ++app.form_index,
			type_id: ++app.form_index,
			required_id: ++app.form_index
		};

		this.handleLabelChange  = this.handleLabelChange.bind(this);
		this.handleTypeChange   = this.handleTypeChange.bind(this);
		this.handleOptionChange = this.handleOptionChange.bind(this);
		this.addOption          = this.addOption.bind(this);
		this.add                = this.add.bind(this);
	}

	componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		let type = 'text', label = '', options_nb = 1, data = [], required = false;

		if (props.element)
		{
			type  = props.element.type;
			label = props.element.label || '';

			options_nb = props.element.data?.length || 1
			data       = props.element.data || [];

			required = props.element.required || false;
		}

		component.setState(
		{
			label: label,
			type: type,
			data: data,
			required: required,

			options_nb: options_nb
		});
	}

	handleRequiredChange = (e) =>
	{
		this.setState({ required: e.target.checked || false });
	}

	handleLabelChange = (e) =>
	{
		this.setState({ label: e.target.value || '' });
	}

	handleTypeChange = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		let value = e.target.value || '';

		state.options_nb = 1;

		if (['select', 'checkbox'].includes(value) === false)
		{
			state.data = [{ id: 0, name: '' }];
		}
		else if (state.data.length < 1)
		{
			state.data = [{ id: 0, name: '' }];
		}

		component.setState(
		{
			type: value,
			data: state.data,
			options_nb: state.data.length
		});
	}

	handleOptionChange = (e, i) =>
	{
		const component = this, props = this.props, state = this.state;

		let value = e.target.value;

		state.data = state.data.map(function (data)
		{
			if (data.id === i)
			{
				data.name = value;
			}

			return data;
		});

		component.setState(
		{
			data: state.data
		});
	}

	addOption = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		state.data.push(
		{
			id: state.options_nb,
			name: ''
		});

		component.setState(
		{
			options_nb: ++state.options_nb
		});
	}

	removeOption = (e, id) =>
	{
		const component = this, props = this.props, state = this.state;

		if (state.data.length > 1) // At least one option is required
		{
			state.data = state.data
			.filter(data => data.id !== id)
			.map(function (data)
			{
				if (Number.isInteger(data.id) && data.id > id) data.id--;

				return data;
			});
		}

		if (--state.options_nb <= 0) // At least one option is required
		{
			state.options_nb = 1;
		}

		component.setState(
		{
			options_nb: state.options_nb,
			data: state.data
		});
	}

	add = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			label: '',
			type: 'text',
			data: [{ id: 0, name: '' }],
			required: false,

			options_nb: 1
		});

		if (props.element)
		{
			props.onAdd(
			{
				label: state.label,
				type: state.type,
				data: state.data,
				required: state.required,

				id: props.element.id,
				_index: props.element._index

			}, Boolean(props.element));
		}
		else
		{
			props.onAdd(
			{
				label: state.label,
				type: state.type,
				data: state.data,
				required: state.required,
			});
		}
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let options = [];

		if (['select', 'checkbox'].includes(state.type))
		{
			let iterator = 0;

			do
			{
				let i = iterator;

				let id = String(i) + '-custom-quote-creation-option';

				let element;

				if (props.element)
				{
					element = state.data.find((data, index) => index === i);
				}
				else
				{
					element = state.data.find(data => data.id === i);
				}

				let delete_option =
				(
					<button className="c-custom-quote-add__remove-option"
						onClick={ function (e) { component.removeOption(e, element.id || i) } }>
						Supprimer
					</button>
				);

				if (state.data.length <= 1)
				{
					delete_option = undefined;
				}

				options.push
				(
					<div className="c-custom-quote-add__select-area" key={ i }>
						<label htmlFor={ id }
							className="c-custom-quote-add__label u-no-select">
							Intitulé de l'option
						</label>

						<div className="c-custom-quote-add__select-option">

							<input type="text" className="c-custom-quote-add__input"
								placeholder="Libellé du choix"
								id={ id } value={ element ? element.name : '' }
								onChange={ function (e)
								{ component.handleOptionChange(e, element.id || i) } } />

							{ delete_option }

						</div>

					</div>
				);

				iterator++;
			}
			while (iterator < state.options_nb);

			options =
			(
				<div className="u-full-width u-margin-top-25">
					{ options }
					<button type="button" className="c-btn c-btn--smaller c-btn--add u-margin-left-10 u-margin-right-15 u-margin-top-10" onClick={ component.addOption }>
						Ajouter un choix
					</button>
				</div>
			);
		}

		var output =
		(
			<div className="c-custom-quote-add">

				<h3 className="c-custom-quote-add__title">
					{ props.element ? 'Modification' : 'Nouvel élément' }
				</h3>

				<div className="c-custom-quote-add__content">

					<div className="c-custom-quote-add__type-area">

						<label htmlFor={ state.type_id }
							className="c-custom-quote-add__label u-no-select">
							Type de champ
						</label>

						<select className="c-custom-quote-add__input" id={ state.type_id }
							onChange={ component.handleTypeChange } value={ state.type }>
							{
								types.map(function (type)
								{
									return (
										<option value={ type.value } key={ type.value }>
											{ type.label }
										</option>
									);
								})
							}
						</select>

					</div>

					<div className="c-custom-quote-add__label-area">

						<label htmlFor={ state.label_id }
							className="c-custom-quote-add__label u-no-select">
							Intitulé du champ
						</label>

						<input type="text" className="c-custom-quote-add__input"
							placeholder="Sera affiché au dessus du champ"
							id={ state.label_id } value={ state.label }
							onChange={ component.handleLabelChange } />

					</div>

					<div className="c-custom-quote-add__required-area">

						<label htmlFor={ state.required_id }
							className="c-custom-quote-add__label u-no-select">
							Champ requis
						</label>

						<input type="checkbox" className="c-form__checkbox"
							id={ state.required_id } checked={ state.required }
							onChange={ component.handleRequiredChange } />

						<label htmlFor={ state.required_id }
							className="c-custom-quote-element__cb"></label>
					</div>

					{ options }

					<div className="u-full-width u-text-right u-margin-top-25">
						<div className={ 'c-btn ' +
							(props.element ? 'c-btn--next' : 'c-btn--icon') }
							onClick={ component.add }>
							{ props.element ? 'Mettre à jour' : 'Ajouter cet élément' }
						</div>
					</div>

				</div>

			</div>
		);

		return output;
	}
}